// extracted by mini-css-extract-plugin
export default {"loading":"insideBounce_loading__pvgaK"};